module.exports = __webpack_public_path__ + "img/seaprojects-logo.b151831b.png";